export default __webpack_public_path__ + "static/media/design.2d974826.png";